import { Component, computed, OnInit, signal, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { BaseComponent } from "../../shared/base.component";
import { NotificationBarComponent } from "../../shared/notification-bar";
import { LoginService } from "./login.service";
import { LoginPictureModel } from "./picture-login/login-picture.viewmodel";
import { PictureLoginRequired, QrCredentials } from "./qr-login/qr-login.component";
import { PageMode } from "./query-params.model";


@Component({
  selector: "app-login",
  templateUrl: "./login.component.html"
})
export class LoginComponent extends BaseComponent implements OnInit {
  override componentTranslationRoot = "password-login";
  @ViewChild("notificationBar", { static: false }) notificationBar!: NotificationBarComponent;

  pageMode = signal<PageMode>(PageMode.Password);
  usePasswordLogin = computed<boolean>(() => this.pageMode() == PageMode.Password);
  usePictureLogin = computed<boolean>(() => this.pageMode() == PageMode.Picture);
  useQrLogin = computed<boolean>(() => this.pageMode() == PageMode.QrCode);

  loginHint = signal<string>("");

  possiblePictures = signal<LoginPictureModel[]>([]);
  qrCredentials = signal<QrCredentials | undefined>(undefined);

  constructor(
    translateService: TranslateService,
    private readonly route: ActivatedRoute,
    private readonly loginService: LoginService
  ) {
    super(translateService);
  }


  ngOnInit(): void {
    this.subscriptionsToRelease.push(
      this.route.queryParamMap.subscribe(params => {
        this.loginHint.set(params.has("Username") || params.get("username") || params.has("login_hint") ?
          params.get("Username") || params.get("username") || params.get("login_hint")!
          : "");

        this.pageMode.set(params.has("page_mode") ? Number(params.get("page_mode")!) : PageMode.Password);

        //expect to be temporary . since edge18 does not allow setting proper cookies
        //we set cookies via code
        if (params.has("FakeAssistant")) {
          document.cookie = "MiaIpOverride=2.2.2.2; domain=.moo.nl; path=/";
        }

        if (params.has("UseNewAuthApp")) {
          document.cookie = "UseNewAuthApp=2; domain=.moo.nl; path=/";
        }
      })
    );
  }

  loginAsSelf(token: string): void {
    this.loginService.login(token);
  }

  showPictureLogin(event: PictureLoginRequired): void {
    this.loginHint.set(event.loginName);
    this.pageMode.set(PageMode.Picture);
    this.qrCredentials.set(event.qrCredentials);
    this.possiblePictures.set(event.passwordPictures);
  }
}
